import { Modal, ModalFuncProps } from 'antd';

export const modalConfirm = (props: ModalFuncProps) => {
  Modal.confirm({
    style: { fontFamily: 'Quicksand' },
    ...props,
  });
};
